import React from "react";
import withStyles from "react-jss";

const styles = (theme) => ({
	root: {
		width: "100%",
		"font-family": theme.fonts.bold,
		marginBottom: "0",
		position: "absolute",
		bottom: "0",
		right: "0",
		left: "0",
		display: "flex",
		flexWrap: "wrap",
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			"& > :first-child": {
				borderRight: "1px solid #e4e8f1",
			},
		},
	},
});

const Component = ({ classes, compareButton, connectButton }) => {
	const preventBehavior = (e) => {
		e.stopPropagation();
		e.preventDefault();
	};

	return (
		<div className={classes.root} onClick={preventBehavior}>
			{compareButton}
			{connectButton}
		</div>
	);
};

const ButtonsLayout = withStyles(styles)(Component);
ButtonsLayout.displayName = "ButtonsLayout";

export default ButtonsLayout;
